import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, Space } from 'antd';
import styled from '@emotion/styled';

import useAuthShopErrorCount from 'hooks/business/authShops/useAuthShopErrorCount';
import { useAuthorization } from 'components/Authorization';
import { useMemoizedFn } from 'ahooks';
import { useTranslate } from '@tolgee/react';
import contentImg from './assets/content.png';
import headerBg from './assets/header-bg.png';
import { ignoreNotificationCache } from 'services/cache';

const ModalContainer = styled(Modal)`
  .ant-modal-header {
    display: flex;
    justify-content: center;
    height: 80px;
    background-image: url(${headerBg});
    background-repeat: no-repeat;
    background-size: cover;
  }

  .ant-modal-title {
    position: relative;
    display: inline-block;
    font-size: 32px;
    line-height: 1.7;
    color: #1d3d9c;
    border-bottom: 12px solid #eec93f;
  }
`;
const ContentText = styled.p`
  font-size: 14px;
  color: var(--fett-text-primary);
  margin-bottom: 7px;
`;
const ImageWrapper = styled.div`
  padding: 8px;
  background: var(--fett-erp-card-bg);

  & > img {
    width: 100%;
    height: 100%;
  }
`;

const setIgnore = (userId?: number | null) => {
  if (userId !== null) {
    ignoreNotificationCache.set('1');
  }
};
const isIgnore = (userId?: number | null) => {
  return userId ? ignoreNotificationCache.get() === '1' : false;
};

const NotificationDialog = () => {
  const { errorCount } = useAuthShopErrorCount();
  const { payload } = useAuthorization<Oversea.Token.Payload>();
  const [visible, setVisible] = useState(false);
  const { t } = useTranslate();

  const handleIgnore = useMemoizedFn(() => {
    setIgnore(payload?.id);
    hideModal();
  });

  const hideModal = useMemoizedFn(() => {
    setVisible(false);
  });

  const renderFooter = useMemo(() => {
    return (
      <Space>
        <Button type="primary" onClick={handleIgnore}>
          {t('notificationDialog.知道了')}
        </Button>
      </Space>
    );
  }, [handleIgnore, t]);

  useEffect(() => {
    if (!isIgnore(payload?.id) && errorCount.shopeeLocalRegisterExceptionNum > 0) {
      setVisible(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorCount.shopeeLocalRegisterExceptionNum]);

  return (
    <ModalContainer
      visible={visible}
      width={760}
      title={t('notificationDialog.通知中心')}
      footer={renderFooter}
      bodyStyle={{ height: 425, overflowY: 'auto' }}
      onCancel={hideModal}
    >
      <ContentText>{t('notificationDialog.p1')}</ContentText>
      <ContentText>{t('notificationDialog.p2')}</ContentText>
      <ImageWrapper>
        <img src={contentImg} alt="content" />
      </ImageWrapper>
    </ModalContainer>
  );
};

export default NotificationDialog;
